function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
 * Base plugin class. Provides basic, common functionality.
 * @class Plugin
 * @since 0.7.0
 * @author  Thomas Erbe <vizuaalog@gmail.com>
 */
var Plugin = /*#__PURE__*/function () {
  /**
   * Create a plugin.
   * @param {object} options The options for this plugin
   */
  function Plugin() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Plugin);

    this.options = _objectSpread(_objectSpread({}, this.constructor.defaultOptions()), options);
    this.parent = this.option('parent', document.body);
  }
  /**
   * Find an option by key.
   * @param {string} key The option key to find.
   * @param {any} defaultValue Default value if an option with key is not found.
   * @returns {any} The value of the option we found, or defaultValue if none found.
   */


  _createClass(Plugin, [{
    key: "option",
    value: function option(key) {
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (!this.options.hasOwnProperty(key) || this.options[key] === null) {
        if (typeof defaultValue === 'function') {
          return defaultValue();
        }

        return defaultValue;
      }

      return this.options[key];
    }
  }], [{
    key: "create",
    value:
    /**
     * Helper method used by the Bulma core to create a new instance.
     * @param  {Object?} options The options object for this instance
     * @return {Plugin|boolean} The newly created instance or false if method is not used
     */
    function create() {
      return false;
    }
    /**
     * Handle parsing the DOM elements.
     * @param {HTMLElement?} element The root element for this instance
     * @return {Plugin|boolean} The new plugin instance, or false if method is not used
     */

  }, {
    key: "parse",
    value: function parse() {
      return false;
    }
    /**
     * Returns a string containing the element class this plugin supports.
     * @returns {string} The class name.
     * @throws {Error} Thrown if this method has not been replaced.
     */

  }, {
    key: "getRootClass",
    value: function getRootClass() {
      throw new Error('The getRootClass method should have been replaced by the plugin being created.');
    }
    /**
     * Returns an object containing the default options for this plugin.
     * @returns {object} The default options object.
     */

  }, {
    key: "defaultOptions",
    value: function defaultOptions() {
      return {};
    }
  }]);

  return Plugin;
}();

export { Plugin as default };